import { DirectiveBinding } from 'vue/types/options';

const bindings = new Map<HTMLElement, DirectiveBinding>();

export function getBinding(el: HTMLElement) {
    return bindings.get(el);
}

export function setBinding(el: HTMLElement, binding: DirectiveBinding) {
    bindings.set(el, binding);
}

export function deleteBinding(el: HTMLElement) {
    bindings.delete(el);
}
